import {
    GET_REGIONALS_DATA
} from './actionTypes';

const initialState = {
    data: {
		divisions: [],
        regions: [],
        municipalities: [],
        units: []
    }
}

const Regionals = (state = initialState, action) => {
	switch (action.type) {
		case GET_REGIONALS_DATA:
			return {
				...state,
                data: action.payload
			}
		default:
			return state;
	}
}

export default Regionals;